import type { Chart } from 'chart.js';

export class ChartUtils {
    static fontFamily = 'Viessmann Web';

    static ticksColor = '#646a6e';

    static ticksGreenColor = '#14874e';

    static labelsColor = '#858585';

    static gridLineColor = '#646a6e';

    static ticks = {
        color: ChartUtils.ticksColor,
        font: {
            family: ChartUtils.fontFamily,
            size: 12
        }
    };

    static labels = {
        font: {
            size: 14,
            family: ChartUtils.fontFamily
        },
        padding: 30,
        usePointStyle: true,
        pointStyle: 'circle',
        color: ChartUtils.labelsColor,
        boxWidth: 40
    };

    static tooltip = {
        backgroundColor: '#FFFFFF',
        titleColor: '#101314',
        bodyColor: '#101314',
        borderColor: '#E0E0E0',
        borderWidth: 1,
        cornerRadius: 8,
        padding: 8,
        titleFont: { size: 14, family: ChartUtils.fontFamily },
        bodyFont: { size: 14, family: ChartUtils.fontFamily },
        footerFont: { size: 14, weight: 600, family: ChartUtils.fontFamily },
        footerColor: '#101314'
    };

    static areaBorderPlugin = {
        id: 'chartAreaBorder',
        afterDraw(chart: Chart) {
            const { ctx, chartArea } = chart;
            if (!chartArea) return;
            ctx.save();
            ctx.strokeStyle = '#e3e3e3';
            ctx.lineWidth = 1;
            ctx.setLineDash([]);
            ctx.lineDashOffset = 0;
            ctx.strokeRect(chartArea.left, chartArea.top, chartArea.width, chartArea.height);
            ctx.restore();
        }
    };

    static splitWideLabelToTwoLinesIfPossible = (label: string, maxLen: number = 10): string | string[] => {
        if (label.length <= maxLen) return label;
        if (!label.includes(' ')) return label;

        const mid = Math.floor(label.length / 2);
        const leftSpace = label.lastIndexOf(' ', mid);
        const rightSpace = label.indexOf(' ', mid);

        let splitIdx: number;
        if (leftSpace === -1) splitIdx = rightSpace;
        else if (rightSpace === -1) splitIdx = leftSpace;
        else splitIdx = Math.abs(mid - leftSpace) < Math.abs(mid - rightSpace) ? leftSpace : rightSpace;

        return [label.slice(0, splitIdx), label.slice(splitIdx + 1)];
    };
}
